interface V3IconSendProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconSend = ({ stroke = "#ABB0BA" }: V3IconSendProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.667 9.333 14 2M14 2 9.667 14A.367.367 0 0 1 9 14L6.667 9.333 2 7a.367.367 0 0 1 0-.667L14 2Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>